module.exports = __webpack_public_path__ + "static/media/asg2.2dda3ecd.png";